<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3 handle-bottom">
            <el-form :inline="true" class="demo-form-inline">
              <div class="uers-left">
                <el-form-item label="投票项：">
                  <el-select
                      v-model="voteId"
                      placeholder="选择类型"
                  >
                    <el-option
                        v-for="(type) in types"
                        :label="type.name"
                        :value="type.voteId"
                    >{{ type.name }}
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                      style="float: right; margin-left: 10px"
                      type="primary"
                      @click="getData"
                      icon="el-icon-search"
                  >查询
                  </el-button
                  >
                </el-form-item>
                <span class="btn-r">
                <el-button
                    type="primary"
                    plain
                    icon="el-icon-plus"
                    @click="addSubmit"
                >新增
                </el-button>&nbsp;&nbsp;
                <el-popover
                    placement="bottom"
                    title="批量导入"
                    width="220"
                    trigger="click"
                >
                  <div>
                    <el-upload
                        class="upload-demo"
                        :action="action"
                        :auto-upload="false"
                        :on-change="uploadChange"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                      <el-button size="small" type="primary"
                      >选择导入模板
                      </el-button
                      >
                    </el-upload>
                    <el-button
                        type="success"
                        @click="download"
                        plain
                        icon="el-icon-download"
                        class="down-template"
                    >下载模板
                    </el-button
                    >
                  </div>
                  <p class="import-text">只能选择 .xls .xlsx 文件</p>
                  <div>
                    <el-button type="success" @click="importData"
                    >导入
                    </el-button>
                  </div>
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-upload2"
                      slot="reference"
                  >导入
                  </el-button
                  >
                </el-popover
                >
              </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="table"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="sor"
                  label="排序"
                  width="80"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.sort }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="名称"
                  width="250"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="banner"
                  label="Banner"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.banner"
                        :preview-src-list="[scope.row.banner]"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="ticket"
                  label="投票数量"
                  width="120"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.ticket }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="disabled"
                  label="状态"
                  width="80"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.disabled == 0 ? "启用" : "禁用" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  label="创建时间"
                  width="180"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditVoteItem
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditVoteItem>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditVoteItem from "../../components/major/EditVoteItem";
import DeleteDialog from "../../components/public/DeleteConfim";
import XLSX from "xlsx";

export default {
  data() {
    return {
      action: localStorage.getItem("url"),
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      projectId: localStorage.getItem("project_Id"),
      voteItemId: "",
      voteId: null,
      types: []
    };
  },
  mounted() {
    this.$axios.post("/Vote/Search/", {projectId: this.projectId}).then((res) => {
      if (res.data.hasError == false) {
        this.types = [...res.data.data];
        if (this.voteId == null && this.types.length > 0) {
          this.voteId = this.types[0].voteId;
          this.getData();
        }
      }
    });
  },
  created() {
    if (this.$route.query.id) {
      this.voteId = parseInt(this.$route.query.id);
      this.getData();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.getData();
    },
    uploadChange(file, fileList) {
      let inputDOM = this.$refs.inputer; // 通过DOM取文件数据
      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var formData = new FormData();
      formData.append("file", f);

      var reader = new FileReader(); //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          } // outdata就是你想要的东西 excel导入的数据
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); // excel 数据再处理
          let ar = [];
          outdata.map((v) => {
            let obj = {};
            obj.name = v.名称;
            obj.disabled = v.禁用;
            obj.sort = v.排序;
            obj.ticket = v.票数;
            obj.banner = v.图片;
            ar.push(obj);
          });
          localStorage.setItem("attr", JSON.stringify(ar));
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    download() {
      var url = localStorage.getItem("url");
      window.open(
          url.substring(0, url.lastIndexOf("/api")) +
          "/data/投票项目.xlsx"
      );
    },
    importData() {
      if (this.voteId) {
        this.attr = JSON.parse(localStorage.getItem("attr"));
        if (this.attr && this.attr.length > 0) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let url = "/VoteItem/" + this.voteId;

          this.$axios
              .patch(url, this.attr)
              .then((res) => {
                if (res.data.hasError == false) {
                  loading.close();
                  this.getData();
                  localStorage.setItem("attr", null);
                  this.$message.success(res.data.message);
                } else {
                  this.$message.error(res.data.message);
                  loading.close();
                }
              })
              .catch(function () {
                loading.close();
              });
        } else {
          this.$message.error("没有可上传的数据");
        }
      } else {
        this.$message.error("请选择投票");
      }
    },
    addSubmit() {
      this.voteItemId = "";
      this.listShow = false;
      this.editShow = true;
      this.editData = {
        sort: 1,
        disabled: 0,
        ticket: 1,
        name: "",
        banner: "",
        voteId: this.voteId,
        viewPage: "",
      };
    },
    handleDelete(index, row) {
      this.voteItemId = row.voteItemId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.voteItemId = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios.delete(`/VoteItem/${this.voteItemId}`).then((res) => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("删除成功！");
          this.delVisible = false;
          this.getData();
        }
      });
    },
    // 获取数据
    getData() {
      this.$axios.post("/VoteItem/Search/", {type: this.voteId}).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    getFunStu() {
      this.editData = null;
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditVoteItem,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

.uers-right {
  float: right;
}

.uers-right-buttom {
  margin-bottom: 19px;
}

.handle-bottom {
  padding-bottom: 20px;
}

.import-bnt {
  float: right;
}

.el-upload--text {
  border: 0;
}
</style>